import actions from './actions'
import reducer from './reducer'

export default {
  name: 'reactorDashboard',
  actions,
  reducer,
}